import {
    type ReasonsToLeaveApiResponse,
    ReasonsToLeaveApiResponseSchema,
} from "@/components/server/EditSuscription/DeleteAccount/types";
import { config } from "@/config";
import type { PauseSuscription } from "@/services/types";
import { getToken } from "@/services/utils";
import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

const BACKEND_URL: string = config?.BACKEND_URL || "";
// const ENV: string = config?.ENV || "";

// Datos simulados de la API (en producción esto vendría de un endpoint real)
const reasonsToLeaveData: ReasonsToLeaveApiResponse = {
    reasons: [
        {
            base: "Ya no necesito el servicio",
            reasones: [
                {
                    razon: {
                        title: "Me voy de vacaciones",
                        body: "💡 Sabías que [**puedes pausar**](#pausar) hasta 3 meses tu suscripción en lugar de cancelar tu suscripción?",
                    },
                    tags: [],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
                {
                    razon: {
                        title: "Me cambio de ciudad",
                        body: "💡 Sabías que [**puedes cambiar**](#cambiar) tu dirección de entrega o elegir un punto de retiro?",
                    },
                    tags: ["Me cambio de comuna", "Me voy de Chile"],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
                {
                    razon: {
                        title: "No me gustó el servicio",
                        body: "🙏🏻 Lamentamos no haber cumplido tus expectativas. Siempre estamos mejorando y, si tuviste algún problema, [**escríbenos**](https://wa.me/+56971295665) para ayudarte.",
                    },
                    tags: [
                        "Poca variedad",
                        "Tamaños poco prácticos",
                        "Personalización limitada",
                        "Precio alto",
                        "Mala calidad de productos",
                        "Problemas de despacho",
                    ],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
            ],
        },
        {
            base: "Problema con el valor del servicio",
            reasones: [
                {
                    razon: {
                        title: "Estoy con problemas económicos",
                        body: "🙏🏻 Lamentamos escuchar eso, no imaginamos por lo que puedas estar pasando.",
                    },
                    tags: [],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
                {
                    razon: {
                        title: "Me parece caro el valor de las cajas",
                        body: "",
                    },
                    tags: [],
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
                {
                    razon: {
                        title: "Me parece caro el despacho",
                        body: "",
                    },
                    tags: [],
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
            ],
        },
        {
            base: "Prefiero otra forma de comprar",
            reasones: [
                {
                    razon: {
                        title: "Prefiero comprar en la feria",
                        body: "💡 Sabías que en Maifud tienes precios muy parecidos a la feria, ahorras el tiempo de ir y cargar bolsas, y además combates el desperdicio de alimentos?",
                    },
                    tags: [
                        "Precios más bajos",
                        "Más variedad",
                        "Productos más frescos",
                        "Puedo elegir lo que compro",
                        "Es parte de mi rutina o paseo",
                    ],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
                {
                    razon: {
                        title: "Prefiero comprar en supermercados",
                        body: "💡 Sabías que en Maifud tienes precios **30%** más bajos que supermercados, ahorras el tiempo de ir, hacer filas y además combates el desperdicio de alimentos?",
                    },
                    tags: [
                        "Cobro automático",
                        "Poca variedad",
                        "No elegir lo que necesito",
                    ],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
                {
                    razon: {
                        title: "Prefiero comprar a granel",
                        body: "💡 ¿Sabías que al estar suscrito puedes comprar a granel con un clic, sin pagar envío extra? Además, puedes elegir el día de entrega para otras compras adicionales a tu caja.",
                    },
                    tags: [
                        "Quiero elegir lo que necesito",
                        "Poca variedad",
                        "No quiero suscribirme",
                        "Prefiero pagar por uso",
                    ],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
            ],
        },
        {
            base: "Problemas con el servicio o la experiencia",
            reasones: [
                {
                    razon: {
                        title: "Tuve problemas con el despacho o la entrega",
                        body: "🙏🏻 Lamentamos escuchar eso, día a día trabajamos para mejorar nuestra logística. Recuerda que cualquier problema nos puedes [**escribir**](https://wa.me/+56971295665) a soporte para ayudarte.",
                    },
                    tags: [
                        "No llegó el pedido",
                        "Llegó muy tarde",
                        "No me avisaron la hora",
                        "Mala atención del repartidor",
                    ],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
                {
                    razon: {
                        title: "Mi pedido llegó incompleto o con errores",
                        body: "🙏🏻 Lamentamos lo ocurrido. No es nuestra política cometer ese tipo de errores. Si tuviste un problema, [**escríbenos**](https://wa.me/+56971295665) a soporte y te ayudamos.",
                    },
                    tags: [
                        "Faltaron productos",
                        "Me llegaron productos incorrectos",
                        "No se respetaron los cambios",
                        "El peso no coincidía",
                    ],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
                {
                    razon: {
                        title: "Tuve problemas usando la plataforma",
                        body: "🙏🏻 Lamentamos escuchar eso. Recuerda que siempre podemos ayudarte a personalizar tu caja o configurar tu cuenta si nos [**escribes a soporte**](https://wa.me/+56971295665).",
                    },
                    tags: [
                        "Difícil personalizar",
                        "Cambios no se guardan",
                        "Problemas de pago",
                        "Página poco amigable",
                    ],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
            ],
        },
        {
            base: "Problemas con los productos",
            reasones: [
                {
                    razon: {
                        title: "No me acomoda la variedad de los productos",
                        body: "😔 Lamentamos que te vayas por eso. Estamos sumando más productos y mejorando la web para que personalizar tu caja sea cada vez más fácil y flexible.",
                    },
                    tags: [
                        "Siempre llegan los mismos",
                        "Demasiado de un solo tipo",
                        "Pocas opciones para elegir",
                        "No se ajusta a mi consumo",
                    ],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
                {
                    razon: {
                        title: "Me sobran productos",
                        body: "💡 Si te sobran productos, [**puedes cambiar**](#cambiar) el tamaño de tu caja, personalizarla para no repetir productos, espaciar las entregas o pausar tu suscripción cuando quieras.",
                    },
                    tags: [
                        "No estoy cocinando tanto",
                        "Productos se repiten",
                        "Se me echan a perder",
                        "Tardan en madurar",
                    ],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
                {
                    razon: {
                        title: "Recibí productos en mal estado o muy maduros",
                        body: "🙏🏻 Lamentamos mucho escuchar eso. No es nuestra política entregar productos en mal estado. Recuerda que siempre podremos darte una solución si nos [**escribes a soporte**](https://wa.me/+56971295665).",
                    },
                    tags: [
                        "Muy maduros o pasados",
                        "Productos con hongos",
                        "Machucados o dañados",
                        "Empaque en mal estado",
                        "Caja llegó manipulada",
                    ],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
                {
                    razon: {
                        title: "No me gustó la calidad de los productos",
                        body: "🙏🏻 Lamentamos no haber cumplido tus expectativas en la calidad. Si quieres, [**escríbenos**](https://wa.me/+56971295665) y buscaremos la mejor solución.",
                    },
                    tags: [
                        "Calidad insatisfactoria",
                        "No cumple expectativas",
                        "Productos inconsistentes",
                    ],
                    regalo: {
                        card: {
                            title: "¡Danos otra oportunidad! 🙏🏻✨",
                            body: "Quédate y te regalamos un **50%** de dscto en tu próxima caja y con **envío gratis**🎁🚚",
                        },
                        aceptacion: {
                            title: "¡Gracias por darnos una nueva oportunidad! 💚",
                            body: "Ya está cargado en tu sesión el descuento y el **envío gratis**para tu siguiente caja 🙌🏻",
                        },
                    },
                    cancelar: {
                        title: "Suscripción cancelada",
                        body: "Tu suscripción ya fue cancelada, lamentamos mucho que te quieras ir 😔\n\n¡Te estaremos esperando si quieres volver! 💚",
                    },
                },
            ],
        },
    ],
};

const fetchReasonsToLeave = async (): Promise<ReasonsToLeaveApiResponse> => {
    // Simular delay de red para testing
    await new Promise((resolve) => setTimeout(resolve, 1));

    const reasons = ReasonsToLeaveApiResponseSchema.parse(reasonsToLeaveData);
    return reasons;
};

// const postDeleteSuscription = async (values: DeleteSuscriptionPost) => {

//   const token = await getToken();
//   const response = await axios.post<PauseSuscription>(
//     `${BACKEND_URL}/api/v1/preferences/cancel_subscription`,
//     values,
//     {
//       headers: { Authorization: `Bearer ${token}` },
//       params: {
//         ...getUIDParam(),
//       },
//     },
//   );
//   return response;
// };

const activateDiscount = async (values: { terminationReason: string }) => {
    const token = await getToken();

    // console.log("DeleteSuscriptionPost");
    // console.log(values);
    const response = await axios.post<PauseSuscription>(
        `${BACKEND_URL}/api/v1/pre_chrun_gift/`,
        values,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );
    console.log(response);
    return response; // Devuelve la respuesta completa de axios
};

// const MockPostDeleteSuscription = async (values: DeleteSuscriptionPost) => {
//   // Simulate network delay
//   await new Promise((resolve) => setTimeout(resolve, 100));
//   console.log(values);
//   // Create a mock response object
//   // Assuming a successful deletion returns a simple status or similar structure that fits PauseSuscription
//   const mockResponse: {
//     data: DeleteSuscriptionPost;
//     status: number;
//     statusText: string;
//     headers: any;
//     config: any;
//     request?: any;
//   } = {
//     data: {} as DeleteSuscriptionPost, // Mock data, adjust based on expected PauseSuscription structure for a success
//     status: 200,
//     statusText: "OK",
//     headers: {},
//     config: {},
//     request: {},
//   };

//   (mockResponse.data as any).status = "Subscription Cancelled";

//   return Promise.resolve(mockResponse);
// };
export const useReasonsToLeaveQuery = () =>
    useQuery({
        queryKey: ["reasons-to-leave"],
        queryFn: fetchReasonsToLeave,
    });

// export const useSuscriptionMutation = () =>
//   useMutation({
//     mutationFn: postDeleteSuscription,
//     onSuccess: () => {
//       // deleteUserFromFirebase();
//     },
//   });

export const useActivateDiscountsMutation = () => {
    return useMutation({
        mutationFn: activateDiscount,
    });
};
